export default __webpack_public_path__ + "static/media/pic3.16c3e7fe.png";